<template>
  <v-container>
    <h1>Beheer gebruikers</h1>
    <v-data-table hide-default-footer :headers="headers" :items="data" class="elevation-1" @click:row="editUser"></v-data-table>
    <v-btn fab color="secondary" title="Nieuwe gebruiker toevoegen" @click="newUser()">
      <v-icon>mdi-plus-thick</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "BeheerGebruikers",
  data: () => ({
    headers: [
      { text: "Naam", value: "Naam" },
      { text: "Rol", value: "Rol" },
      { text: "Status", value: "Status" },
      { text: "Laatste login", value: "LaatsteLogin" },
      { text: "Profiel", value: "Profiel" }
    ],
    data: [],
  }),
  methods: {
    loadData: function () {
      this.$api.pUsersGet().then((response) => {
        this.data = response.data;
      });
    },
    editUser: function(row) {
        this.$router.push({ name: "beheergebruiker", params: { id: row.Id } });
    },
    newUser: function() {
        this.$router.push({ name: "newgebruiker", params: { id:null} });
    },
  },
  watch: {},
  mounted() {
    this.loadData();
  },
};
</script>